import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { PRODUCT_CARD_SORT_BY_VALUES } from "@/features/SKUStore/collections/productCardListOptions";
import { COLLECTION_TABS } from "@/features/SKUStore/components/Collections/SKUStoreCollectionView";
import { SKUStorePage } from "@/features/SKUStore/SKUStorePage";

// Source of truth for the selected taxonomy, its tab and the grid sort, so any
// landing view can be reloaded or shared. `.catch(undefined)` keeps a bad value
// from throwing out of validateSearch to the error boundary.
const skuStoreLandingSearchSchema = z.object({
  collection: z.string().optional().catch(undefined),
  category: z.string().optional().catch(undefined),
  tag: z.string().optional().catch(undefined),
  tab: z.enum(COLLECTION_TABS).optional().catch(undefined),
  sort_by: z.enum(PRODUCT_CARD_SORT_BY_VALUES).optional().catch(undefined),
});

export const Route = createFileRoute("/_auth/sku-store/$siteId/")({
  component: SKUStorePage,
  validateSearch: zodValidator(skuStoreLandingSearchSchema),
});
